<template>
    <div id="trx-bill-payment-bill-corp-container">
      <f7-list form class="form-group" v-show="showFormSet.billPayment">
        <f7-list-input
            input-id     ="billAccountName"
            name         ="billAccountName"
            type         ="text"

            :label       ="$t('beneficiary-bill-account-name')"
            :placeholder ="$t('beneficiary-bill-account-name')"
            :value       ="bankAccountName"
            @input       ="setBankAccountName($event.target.value); validateInput($event.target); setInput($event.target)"
            
            maxlength    ="100"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>

        <f7-list-input
            input-id     ="billAccountNo"
            name         ="billAccountNo"
            type         ="text"

            :label       ="$t('beneficiary-bill-account-no')"
            :placeholder ="$t('beneficiary-bill-account-no')"
            :value       ="bankAccountNo"
            @input       ="setBankAccountNo($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="30"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'beneficiaryName',
          'bankAccountNo',
          'bankAccountName',
          'showPreloaderState'
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setBankAccountNo',
          'setBankAccountName',
          'setBeneficiaryName',
          'setShowPreloaderState',
      ]),

      validateInput(inputEl){
        this.$emit("validateInput", inputEl);
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }

    }
  }
</script>